import { render, staticRenderFns } from "./resume-block.vue?vue&type=template&id=ac1af51e&scoped=true&"
import script from "./resume-block.vue?vue&type=script&lang=js&"
export * from "./resume-block.vue?vue&type=script&lang=js&"
import style0 from "./resume-block.vue?vue&type=style&index=0&id=ac1af51e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1af51e",
  null
  
)

export default component.exports